import { render } from "./UnCryptosNavigation.vue?vue&type=template&id=629049ec&scoped=true"
import script from "./UnCryptosNavigation.vue?vue&type=script&lang=js"
export * from "./UnCryptosNavigation.vue?vue&type=script&lang=js"

import "./UnCryptosNavigation.vue?vue&type=style&index=0&id=629049ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629049ec"]])

export default __exports__